import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIonRouter } from '@ionic/react';
import { OnBoardingTypes } from '../redux/onBoarding/types';
import { PublicRoutes } from '../routes/navigation';
import { fetchOnBoardingInfo, fetchOnBoardingQuestion, fetchOnBoardingReviews } from '../redux/onBoarding/thunk';
import { getNextStep, getOnBoardingID, getRedirectToken } from '../redux/onBoarding/selector';
import { useHistory } from 'react-router-dom';
import useLangs from '../context/LangsContext';

const useOnBoardingNextStep = () => {
  const dispatch = useDispatch();

  const router = useIonRouter();
  const history = useHistory();
  const { locale } = useLangs();

  const nextStep = useSelector(getNextStep);
  const onBoardingId = useSelector(getOnBoardingID);
  const token = useSelector(getRedirectToken);

  const nextStepAction = useCallback(async () => {
    if (!onBoardingId) return;
    if (!nextStep) {
      router.push(`${PublicRoutes.ON_BOARDING_REDIRECT}`.replace(':boardId', onBoardingId));
      return;
    }

    switch (nextStep?.type) {
      case OnBoardingTypes.QUESTION:
        await dispatch(fetchOnBoardingQuestion(nextStep.id));
        history.push(
          `${PublicRoutes.ON_BOARDING_QUESTION.replace(':boardId', onBoardingId).replace(':id', nextStep.id)}`,
          { isNextButton: true }
        );
        return;
      case OnBoardingTypes.INFO:
        await dispatch(fetchOnBoardingInfo(nextStep.id));
        history.push(`${PublicRoutes.ON_BOARDING_INFO.replace(':boardId', onBoardingId).replace(':id', nextStep.id)}`, {
          isNextButton: true,
        });
        return;
      case OnBoardingTypes.RESULT:
        history.push(
          `${PublicRoutes.ON_BOARDING_RESULT.replace(':boardId', onBoardingId).replace(':id', nextStep.id)}`,
          { isNextButton: true }
        );
        return;
      case OnBoardingTypes.RESULT_INFO:
        history.push(
          `${PublicRoutes.ON_BOARDING_RESULT_INFO.replace(':boardId', onBoardingId).replace(':id', nextStep.id)}`,
          { isNextButton: true }
        );
        return;
      case OnBoardingTypes.REVIEWS:
        await dispatch(fetchOnBoardingReviews(locale));
        history.push(
          `${PublicRoutes.ON_BOARDING_REVIEWS.replace(':boardId', onBoardingId).replace(':id', nextStep.id)}`,
          { isNextButton: true }
        );
        return;
      case OnBoardingTypes.SPECIALISTS_LIST:
        history.push(
          `${PublicRoutes.ON_BOARDING_SPECIALIST.replace(':boardId', onBoardingId).replace(':id', nextStep.id)}`,
          { isNextButton: true }
        );
        return;
    }
  }, [nextStep, onBoardingId, router, locale, token]);

  return nextStepAction;
};

export default useOnBoardingNextStep;
